/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminviewmode2Inputs */

const en_adminviewmode2 = /** @type {(inputs: Adminviewmode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin View Mode`)
};

const de_adminviewmode2 = /** @type {(inputs: Adminviewmode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Ansichtsmodus`)
};

/**
* | output |
* | --- |
* | "Admin View Mode" |
*
* @param {Adminviewmode2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminviewmode2 = /** @type {((inputs?: Adminviewmode2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminviewmode2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminviewmode2(inputs)
	return de_adminviewmode2(inputs)
});
export { adminviewmode2 as "adminViewMode" }